<template>
  <div>
    <div class="banner sign-bn">
        <img src="@/assets/images/banner6.png" alt="">
        <h2 class="title">Sign up｜歡迎加入我們</h2>
    </div>
    <div class="wrap">
        <section id="tabs-block" class="section">
            <ul class="text-center">
                <li><a href="javascript:;">
                    <div class="name">租約<br>審閱</div>
                    <p>contract</p>
                </a></li>
            </ul>
        </section>
        <section class="section intro-section">
            <div class="intro">
                <h3>租約審閱</h3>
                <div class="get_content">
                    {{ the_content }}
                </div>
                <!-- <ol>
                    <li>簽約前須詳閱承租須知，若無視同同意該入住須知，簽約入住後必須配合不得異議。</li>
                    <li>退租須提前一個月通知，若要提前退租而未通知，必須介紹偕同新住戶來簽約。</li>
                    <li>辦理Check on當天需全部交回本大樓的鑰匙等相關入住物品，若有毀損依簽約照價賠賞，消耗品除外，但若入住後發現有毀損需通知管理人員處理，否則視同接受，退租時不得有異議。</li>
                    <li>館內無法攜帶寵物入住，若有發現必須負責該樓層消毒。</li>
                    <li>租金按時繳納，若延遲10天以上按月租的金額 %利息計算。</li>
                    <li>租金雙方協為台幣NT$<span class="line" style="width: 150px;">&nbsp;</span>元，每月5號支付，可以電匯、現金或是支票支付，不得延期，延期請依遵第5點。</li>
                    <li>月租押金一個月。備註<span class="line">&nbsp;</span></li>
                    <li>契約若有爭議，以台中地方法院為主要協調法院。</li>
                    <li>若無異議雙方簽訂此約，甲乙雙方各持一份</li>
                </ol> -->
                <!-- <div class="row info-list">
                    <div class="col col2">
                        <ul>
                            <li><span class="name">甲方</span><span class="text"><b>高典物業管理顧問有限公司</b></span>
                            <li><span class="name">姓名</span><span class="text">許謙帟</span></li>
                            <li><span class="name">統編</span><span class="text">42890700</span></li>
                            <li><span class="name">地址</span><span class="text">臺中市西區安龍里民權路185號4樓之9</span></li>
                            <li><span class="name">電話</span><span class="text">04-22345678</span></li>
                            <li>&nbsp;</li><li>&nbsp;</li>
                            <li><span class="name">簽章</span><span class="line">&nbsp;</span></li>
                        </ul>
                    </div>
                    <div class="col col2">
                        <ul>
                            <li>乙方</li>
                            <li>姓名</li>
                            <li>身分證</li>
                            <li>地址</li>
                            <li>聯絡手機</li>
                            <li>身分證正反影本</li>
                            <li>&nbsp;</li>
                            <li><span class="name">簽章</span><span class="line">&nbsp;</span></li>
                        </ul>
                    </div>
                </div> -->
                <div class="btn-block text-center">
                    <a href="./download/lease.pdf" target="_blank" class="btn btn-br">下載列印</a>
                </div>
            </div>
        </section>
    </div>
  </div>
</template>

<script>

export default {
    name: 'sign',
    data () {
        return {
            the_content: ''
        }
    },
    beforeMount: function () {
        const formData = new FormData();
        formData.append('CMD', 'SignList');
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
        .then(response => {
            // console.log(response);
            if (response.data.result == false) {
                console.log('SignList: Server Error');
            }else {
                const get_content = response.data.content;
                // const get_imgs = response.data.images_url;
                // const get_pdfs = response.data.pdf_url;
                this.the_content = get_content;
                // this.the_imgs = JSON.parse(get_imgs);
                // this.the_pdfs = get_pdfs;
            }
        })
        .catch(error => {
            console.log(error);
        })
    }
};
</script>

<style>
.get_content {
    white-space: pre-line;
    margin-bottom: 5px;
}
</style>
